(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cartdrawer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mandibule-cart-drawer')) {
    customElements.define('mandibule-cart-drawer', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-mcd-dialog]');
        this.items = this.querySelector('[data-mcd-items]');
        this.empty = this.querySelector('[data-mcd-empty]');
        this.foot = this.querySelector('[data-mcd-foot]');
        this.loading = this.querySelector('[data-mcd-loading]');
        this.count = this.querySelector('[data-mcd-count]');
        this.subtotal = this.querySelector('[data-mcd-subtotal]');
        this.note = this.querySelector('[data-mcd-note]');
        this.shipping = this.querySelector('[data-mcd-shipping]');
        this.shippingText = this.querySelector('[data-mcd-shipping-text]');
        this.shippingBar = this.querySelector('[data-mcd-shipping-bar]');
        this.currency = this.dataset.currency || 'EUR';
        this.locale = this.dataset.locale || 'en';
        this.lastItemCount = 0;
        this.noteTimer = null;

        this.openHandler = () => this.open();
        this.externalCartHandler = () => this.open(true);
        this.submitHandler = (event) => this.handleProductSubmit(event);

        document.addEventListener('mandibule:cart-open', this.openHandler);
        document.addEventListener('cart:add', this.externalCartHandler);
        document.addEventListener('cart:update', this.externalCartHandler);
        document.addEventListener('product:added', this.externalCartHandler);
        document.addEventListener('submit', this.submitHandler, true);

        this.querySelectorAll('[data-mcd-close]').forEach((button) => {
          button.addEventListener('click', () => this.close());
        });

        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });

        this.items?.addEventListener('click', (event) => this.handleItemAction(event));
        this.note?.addEventListener('input', () => this.scheduleNoteUpdate());
        this.refresh();
      }

      disconnectedCallback() {
        document.removeEventListener('mandibule:cart-open', this.openHandler);
        document.removeEventListener('cart:add', this.externalCartHandler);
        document.removeEventListener('cart:update', this.externalCartHandler);
        document.removeEventListener('product:added', this.externalCartHandler);
        document.removeEventListener('submit', this.submitHandler, true);
      }

      get rootRoute() {
        return window.Shopify?.routes?.root || '/';
      }

      async open(refreshFirst = false) {
        if (!this.dialog) return;
        if (!this.dialog.open) this.dialog.showModal();
        if (refreshFirst) await this.refresh();
      }

      close() {
        if (this.dialog?.open) this.dialog.close();
      }

      async refresh() {
        this.loading.hidden = false;
        try {
          const response = await fetch(`${this.rootRoute}cart.js`, {
            headers: { Accept: 'application/json' }
          });
          if (!response.ok) throw new Error('Cart request failed');
          const cart = await response.json();
          this.render(cart);
          return cart;
        } finally {
          this.loading.hidden = true;
        }
      }

      render(cart) {
        this.lastItemCount = cart.item_count;
        this.count.textContent = cart.item_count;
        this.items.innerHTML = cart.items.map((item) => this.itemMarkup(item)).join('');
        this.empty.hidden = cart.item_count !== 0;
        this.foot.hidden = cart.item_count === 0;
        this.subtotal.textContent = this.money(cart.items_subtotal_price, cart.currency);
        this.renderShipping(cart.item_count);
        if (this.note && document.activeElement !== this.note) this.note.value = cart.note || '';
        document.dispatchEvent(new CustomEvent('mandibule:cart-updated', { detail: { cart } }));
      }

      renderShipping(itemCount) {
        if (!this.shipping || !this.shippingText || !this.shippingBar) return;
        const threshold = Math.max(1, Number(this.dataset.freeShippingThreshold) || 2);
        const unlocked = itemCount >= threshold;
        this.shipping.hidden = itemCount === 0;
        this.shipping.classList.toggle('is-unlocked', unlocked);
        this.shippingText.textContent = unlocked
          ? this.dataset.freeShippingUnlocked
          : this.dataset.freeShippingProgress.replace('[count]', String(threshold - itemCount));
        this.shippingBar.style.width = `${Math.min(100, itemCount / threshold * 100)}%`;
      }

      itemMarkup(item) {
        const image = item.image ? `${item.image}${item.image.includes('?') ? '&' : '?'}width=180` : '';
        const variant = item.variant_title && item.variant_title !== 'Default Title'
          ? `<p class="mcd__item-variant">${this.escape(item.variant_title)}</p>`
          : '';

        return `
          <article class="mcd__item" data-key="${this.escape(item.key)}">
            <a class="mcd__item-image" href="${this.escape(item.url)}">
              ${image ? `<img src="${this.escape(image)}" alt="" width="180" height="224" loading="lazy">` : ''}
            </a>
            <div class="mcd__item-info">
              <a class="mcd__item-title" href="${this.escape(item.url)}">${this.escape(item.product_title)}</a>
              ${variant}
              <div class="mcd__quantity">
                <button type="button" data-action="decrease" aria-label="${this.escape(this.dataset.minusLabel)}">−</button>
                <span>${item.quantity}</span>
                <button type="button" data-action="increase" aria-label="${this.escape(this.dataset.plusLabel)}">+</button>
              </div>
            </div>
            <div class="mcd__item-aside">
              <span class="mcd__item-price">${this.money(item.final_line_price)}</span>
              <button class="mcd__remove" type="button" data-action="remove">${this.escape(this.dataset.removeLabel)}</button>
            </div>
          </article>`;
      }

      async handleItemAction(event) {
        const button = event.target.closest('[data-action]');
        const item = event.target.closest('[data-key]');
        if (!button || !item) return;

        const quantity = Number(item.querySelector('.mcd__quantity span')?.textContent || 1);
        const action = button.dataset.action;
        let nextQuantity = quantity;
        if (action === 'increase') nextQuantity += 1;
        if (action === 'decrease') nextQuantity = Math.max(0, quantity - 1);
        if (action === 'remove') nextQuantity = 0;

        button.disabled = true;
        try {
          const response = await fetch(`${this.rootRoute}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: item.dataset.key, quantity: nextQuantity })
          });
          if (!response.ok) throw new Error('Cart change failed');
          this.render(await response.json());
        } finally {
          button.disabled = false;
        }
      }

      scheduleNoteUpdate() {
        window.clearTimeout(this.noteTimer);
        this.noteTimer = window.setTimeout(() => {
          fetch(`${this.rootRoute}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ note: this.note.value })
          });
        }, 500);
      }

      handleProductSubmit(event) {
        const form = event.target.closest('form[action*="/cart/add"]');
        if (!form) return;
        const before = this.lastItemCount;
        window.setTimeout(async () => {
          const cart = await this.refresh();
          if (cart?.item_count > before) this.open();
        }, 650);
      }

      money(cents, currency = this.currency) {
        try {
          return new Intl.NumberFormat(this.locale, { style: 'currency', currency }).format(cents / 100);
        } catch {
          return `${(cents / 100).toFixed(2)} ${currency}`;
        }
      }

      escape(value) {
        return String(value ?? '').replace(/[&<>'"]/g, (character) => ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          "'": '&#39;',
          '"': '&quot;'
        })[character]);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menuhihi"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mandibule-header')) {
    customElements.define('mandibule-header', class extends HTMLElement {
      connectedCallback() {
        this.menu = this.querySelector('[data-mhd-menu]');
        this.search = this.querySelector('[data-mhd-search]');
        this.menuTrigger = this.querySelector('[data-mhd-menu-open]');
        this.searchTrigger = this.querySelector('[data-mhd-search-open]');
        this.onScroll = this.onScroll.bind(this);

        this.menuTrigger?.addEventListener('click', () => this.openDialog(this.menu, this.menuTrigger));
        this.searchTrigger?.addEventListener('click', () => {
          this.openDialog(this.search, this.searchTrigger);
          requestAnimationFrame(() => this.querySelector('[data-mhd-search-input]')?.focus());
        });

        this.querySelectorAll('[data-mhd-dialog-close]').forEach((button) => {
          button.addEventListener('click', () => this.closeParentDialog(button));
        });

        this.querySelectorAll('.mhd__dialog').forEach((dialog) => {
          dialog.addEventListener('click', (event) => {
            if (event.target === dialog) dialog.close();
          });
          dialog.addEventListener('close', () => this.syncTriggers());
        });

        this.querySelector('[data-mhd-cart-open]')?.addEventListener('click', (event) => {
          const cartDrawer = document.querySelector('mandibule-cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            event.preventDefault();
            cartDrawer.open();
            return;
          }

          if (window.MandibuleCart && typeof window.MandibuleCart.open === 'function') {
            event.preventDefault();
            window.MandibuleCart.open();
            return;
          }

          if (cartDrawer) {
            event.preventDefault();
            document.dispatchEvent(new CustomEvent('mandibule:cart-open'));
          }
        });

        document.addEventListener('mandibule:cart-updated', (event) => {
          this.updateCartCount(event.detail?.cart?.item_count ?? 0);
        });

        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
      }

      openDialog(dialog, trigger) {
        if (!dialog || dialog.open) return;
        dialog.showModal();
        trigger?.setAttribute('aria-expanded', 'true');
      }

      closeParentDialog(button) {
        button.closest('dialog')?.close();
      }

      syncTriggers() {
        this.menuTrigger?.setAttribute('aria-expanded', String(Boolean(this.menu?.open)));
        this.searchTrigger?.setAttribute('aria-expanded', String(Boolean(this.search?.open)));
      }

      updateCartCount(count) {
        const bubble = this.querySelector('[data-mhd-cart-count]');
        if (!bubble) return;
        bubble.textContent = count;
        bubble.hidden = count === 0;
      }

      onScroll() {
        this.classList.toggle('is-scrolled', window.scrollY > 24);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pageproduit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mandibule-product-page-v2')) {
    customElements.define('mandibule-product-page-v2', class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-option-position]').forEach((fieldset) => {
          const checkedInput = fieldset.querySelector('[data-option-value]:checked');
          const selectedLabel = fieldset.querySelector('[data-selected-option]');
          if (checkedInput && selectedLabel) selectedLabel.textContent = checkedInput.value;
        });

        this.querySelectorAll('[data-option-value]').forEach((input) => {
          input.addEventListener('change', () => this.onOptionChange(input));
        });

        const json = this.querySelector('[data-product-json]');
        if (!json) return;
        this.product = JSON.parse(json.textContent);
        this.form = this.querySelector('.mpd__form');
        this.variantInput = this.querySelector('[data-variant-id]');
        this.addButton = this.querySelector('[data-add-to-cart]');
        this.preorderMode = this.dataset.preorderMode === 'true';

        this.querySelectorAll('[data-media-target]').forEach((button) => {
          button.addEventListener('click', () => this.selectMedia(button.dataset.mediaTarget));
        });

        this.form?.addEventListener('submit', (event) => this.addToCart(event));
      }

      selectMedia(mediaId) {
        this.querySelectorAll('[data-media-id]').forEach((media) => {
          media.classList.toggle('is-active', media.dataset.mediaId === String(mediaId));
        });
        this.querySelectorAll('[data-media-target]').forEach((button) => {
          const active = button.dataset.mediaTarget === String(mediaId);
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
      }

      onOptionChange(input) {
        const fieldset = input.closest('[data-option-position]');
        const selectedLabel = fieldset?.querySelector('[data-selected-option]');
        if (selectedLabel) selectedLabel.textContent = input.value;

        const selections = [...this.querySelectorAll('[data-option-value]:checked')].map((item) => item.value);
        const variant = this.product.variants.find((candidate) => candidate.options.every((value, index) => value === selections[index]));
        this.updateVariant(variant);
      }

      updateVariant(variant) {
        const available = Boolean(variant?.available);
        if (variant && this.variantInput) this.variantInput.value = variant.id;

        this.querySelector('[data-product-price]').textContent = variant ? this.money(variant.price) : '';
        const compare = this.querySelector('[data-product-compare]');
        const showCompare = Boolean(variant?.compare_at_price && variant.compare_at_price > variant.price);
        compare.hidden = !showCompare;
        if (showCompare) compare.textContent = this.money(variant.compare_at_price);

        this.addButton.disabled = !available;
        this.querySelector('[data-add-price]').hidden = !available;
        if (available) this.querySelector('[data-add-price]').textContent = this.money(variant.price, false);

        const label = available
          ? (this.preorderMode ? this.dataset.preorderLabel : this.dataset.addLabel)
          : this.dataset.soldOutLabel;
        this.querySelector('[data-add-label]').textContent = label;
        const featuredMediaId = variant?.featured_media?.id || variant?.featured_image?.id;
        if (featuredMediaId) this.selectMedia(featuredMediaId);
        this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant } }));
        if (variant) window.history.replaceState({}, '', `${this.dataset.productUrl}?variant=${variant.id}`);
      }

      async addToCart(event) {
        event.preventDefault();
        if (!this.form || this.addButton.disabled) return;
        this.addButton.disabled = true;
        this.addButton.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(this.form)
          });
          if (!response.ok) throw new Error('Unable to add product');
          await response.json();

          if (document.querySelector('mandibule-cart-drawer')) {
            document.dispatchEvent(new CustomEvent('cart:add'));
          } else {
            window.location.href = this.dataset.cartUrl;
          }
        } catch (error) {
          window.location.href = this.dataset.cartUrl;
        } finally {
          this.addButton.disabled = false;
          this.addButton.removeAttribute('aria-busy');
        }
      }

      money(cents, withCurrency = true) {
        const currency = this.product.currency || window.Shopify?.currency?.active || 'EUR';
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency,
            currencyDisplay: withCurrency ? 'symbol' : 'narrowSymbol'
          }).format(cents / 100);
        } catch {
          return `${(cents / 100).toFixed(2)} ${currency}`;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trackorder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mandibule-order-tracker')) {
    customElements.define('mandibule-order-tracker', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-tracking-form]');
        this.input = this.querySelector('[data-tracking-number]');
        this.error = this.querySelector('[data-tracking-error]');
        this.form?.addEventListener('submit', (event) => this.submit(event));
        this.input?.addEventListener('input', () => {
          if (this.error) this.error.hidden = true;
          this.input?.removeAttribute('aria-invalid');
        });
      }

      submit(event) {
        event.preventDefault();
        const trackingNumber = this.input?.value.trim();
        if (!trackingNumber) {
          if (this.error) this.error.hidden = false;
          this.input?.setAttribute('aria-invalid', 'true');
          this.input?.focus();
          return;
        }

        const url = `https://t.17track.net/en#nums=${encodeURIComponent(trackingNumber)}`;
        const trackingWindow = window.open(url, '_blank', 'noopener,noreferrer');
        if (trackingWindow) trackingWindow.opener = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
